import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type BarKpiDataObject } from '../../types'

export interface TotalRegisteredState {
  isLoading: boolean
  error: boolean
  data: BarKpiDataObject | undefined
  httpStatus: number
}

const initialState: TotalRegisteredState = {
  isLoading: true,
  error: false,
  data: undefined,
  httpStatus: 0
}

const totalRegisteredSlice = createSlice({
  name: 'totalRegistered',
  initialState,
  reducers: {
    totalRegisteredLoadingAction: (state) => {
      return {
        isLoading: true,
        error: false,
        data: undefined,
        httpStatus: 0
      }
    },
    totalRegisteredUpdateAction: (state, action: PayloadAction<{ data: BarKpiDataObject, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: false,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    totalRegisteredErrorAction: (state, action: PayloadAction<number>) => {
      return {
        isLoading: false,
        error: true,
        data: undefined,
        httpStatus: action.payload
      }
    }
  }
})

export const {
  totalRegisteredLoadingAction,
  totalRegisteredUpdateAction,
  totalRegisteredErrorAction
} = totalRegisteredSlice.actions

export default totalRegisteredSlice.reducer
